import { motion } from 'framer-motion';
import { UpsertPriceTableForm } from '@/components/forms/commercial/price-table';

export function PriceTableCreatePage() {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <UpsertPriceTableForm />
    </motion.div>
  );
}
